module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"update-product":"Update Product","product-updated":"Product updated","failed-update-product":"Failed to update product","create-product":"Create Product","product-created":"Product created","failed-create-product":"Failed to create product","country-of-origin":"Country of Origin","commodity-code":"Commodity Code"}}')
  delete Component.options._Ctor
}
